

import React, {Suspense} from 'react';
import {useTranslation} from "react-i18next";
import PortfolioApi from "../components/api/portfolio_api";
import {Link} from "react-router-dom";
import Helmet from "react-helmet";
import ServicesApi from "../components/api/services_api";
import ServicesPage from "./services";
import SectionServices from "../components/sections/services";
import {MotionAnimate} from "react-motion-animate";
import ScienceWorkApi from "../components/api/s_work_api";
import BooksSection from "../components/sections/products/book";
import SectionStackTechnologies from "../components/sections/stack-technologies";
import {
    CheckCircle,
    Code,
    Compass,
    Lightbulb,
    TabletSmartphone,
    Book,
    Rss,
    GraduationCap,
    MonitorPlay,
    SquareArrowOutUpRight
} from "lucide-react";

const Information = React.lazy(() => import("../components/sections/qa"));

function WorkPage(props) {

    const { t, i18n } = useTranslation()

    const _workProcessData = [
        {
            title: "Discovery",
            description: "objectives, larget audience, and urique requirements."
        },
        {
            title: "Design & Develop",
            description: "Itranslate Insights hto tangitle designs, crating intuitive interfaces and seeniess esperiences."
        },
        {
            title: "Test & Launch",
            description: "I rigorously test the product to ensure functionalky and performance before a smooth and successful launch"
        }
    ];

    const stack = [
        'Html', 'CSS', 'JS', 'Bootstrap', 'React JS', 'PHP', 'Laravel', 'MySQL', 'Git'
    ];

    const steps = [
        {
            id: 1,
            icon: <Lightbulb className="w-6 h-6 text-indigo-600" size={35} />,
            title: "1. Discovery & Strategy",
            description: "We start by diving deep into your goals, target audience, and project requirements to map out a clear, actionable blueprint."
        },
        {
            id: 2,
            icon: <Compass className="w-6 h-6 text-indigo-600" size={35} />,
            title: "2. Design & Wireframing",
            description: "Next, we translate ideas into visual concepts, creating intuitive user interfaces and wireframes for your review and feedback."
        },
        {
            id: 3,
            icon: <Code className="w-6 h-6 text-indigo-600" size={35} />,
            title: "3. Development & Testing",
            description: "Using modern, clean code, I bring the designs to life while conducting rigorous testing to ensure everything runs flawlessly."
        },
        {
            id: 4,
            icon: <CheckCircle className="w-6 h-6 text-indigo-600" size={35} />,
            title: "4. Launch & Support",
            description: "Your project goes live! Post-launch, I provide ongoing optimization and support to ensure sustained long-term success."
        }
    ];

    return (<div className={'h-auto'}>

        <Helmet>
            <title>Work - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5 pb-4">

            {/*<h1 className={'opacity-25 mb-5'} style={{fontSize: '17vw'}}>Work</h1>*/}

            <p>
                💡 Короткий чек-лист для перевірки (зверху вниз):
            </p>
            <h2 className={'mt-5'}> Моя робота (Опис) — Хто я?</h2>
            <p>
                1. Головний екран: Моя робота (Опис)
                Чому тут: Це ваше позиціонування (УТП — унікальна торгова пропозиція). Відвідувач за перші 3 секунди має зрозуміти, хто ви, чим займаєтесь і яку його проблему можете вирішити.
            </p>
            <h2 className={'mt-5'}>
                My Work
            </h2>
            <p className="text-justify lead mt-5">
                Розробкою програм та написанням сайтів я займаюся основну частину свого часу, оскільки це моя профільна робота за спеціальністю. В процесі розробки розробляється технічне завдання, яке буде слідувати за виконанням проектної роботи. Кожен проект має індивідуальний підхід, який проявляється в поглибленні предметної області, що дає найкращий результат процесу розробки та гарну програму в результаті.
            </p>

            <div className="d-flex flex-wrap justify-content-between align-items-start mt-5">

                {
                    [
                        {
                            icon: <TabletSmartphone />,
                            label: "nav.apps",
                            url: "https://apps.lukyanchuk.com"
                        },
                        {
                            icon: <Book />,
                            label: "nav.books",
                            url: "https://books.lukyanchuk.com"
                        },
                        {
                            icon: <Rss />,
                            label: "nav.blog",
                            url: "https://lukyanchuk.com"
                        },
                        {
                            icon: <MonitorPlay />,
                            label: "nav.courses",
                            url: "https://youtube.com/"
                        },
                        {
                            icon: <GraduationCap />,
                            label: "nav.science-work",
                            url: "/work/science-work"
                        },
                    ].map((item, i) => <div className="col-md-2">
                        <div className="mt-3">
                            {item.icon}
                            <Link to={item.url} className={'p-1 nav-link'}>
                                <b className={'border-bottom'}> {t(item.label)} </b>
                                <SquareArrowOutUpRight size={15} />
                            </Link>
                        </div>
                    </div>)
                }
            </div>


            <h2 className={'mt-5'}>Послуги — Що я пропоную?</h2>
            <p>
                2. Послуги
                Чому тут: Одразу після того, як людина зрозуміла вашу сферу, вона шукає конкретику: "Що саме я можу тут замовити і чи підходить це мені?".
            </p>

            {/*<SectionServices />*/}

            <h2 className={'mt-5'}> Портфоліо — Як це виглядає на практиці?</h2>
            <p>
                3. Портфоліо
                Чому тут: Найкраще підтвердження ваших послуг — це реальні кейси. Клієнт бачить послугу й одразу хоче подивитися, як ви її виконували для інших.
            </p>

            <h2 className={'mt-5'}>Технології та Робочий процес — За допомогою чого і як я це роблю?</h2>
            <p>
                4. Мій робочий процес (або Технології)
                Чому тут: Людина вже побачила, що ви робите (послуги) і який результат (портфоліо). Тепер треба показати, як саме ви це робите. Це знімає страх невідомості та демонструє ваш професіоналізм.

                Порада: Розділи «Мій робочий процес» та «Технології» можна об'єднати або пустити один за одним (наприклад, процес, а всередині або поруч — стек технологій).

            </p>
            <section className="bg-slate-50 py-20 px-4 sm:px-6 lg:px-8 font-sans mt-5">
                <div className="max-w-6xl mx-auto">

                    {/* Section Header */}
                    <div className="text-center mb-16">
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
                            My Work Process
                        </h2>
                        <p className="max-w-2xl mx-auto text-lg text-slate-600">
                            A structured, transparent approach designed to take your project from a blank canvas to a successful digital reality.
                        </p>
                    </div>

                    {/* Process Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative d-flex flex-wrap">
                        {steps.map((step, index) => (
                            <div key={step.id} className="col-md-6 col-12 p-3">

                                {/* Connector line for desktop view */}
                                {index < steps.length - 1 && (
                                    <div className="hidden lg:block absolute top-12 left-1/2 w-full h-0.5 bg-slate-200 group-hover:bg-indigo-300 transition-colors duration-300 z-0" />
                                )}

                                {/* Step Card */}
                                <div className="p-4 rounded-5 relative bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 z-10 flex flex-col h-full">

                                    {/* Icon Wrapper */}
                                    <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center mb-6 group-hover:bg-indigo-100 transition-colors duration-300">
                                        {step.icon}
                                    </div>

                                    {/* Content */}
                                    <h3 className="text-xl font-bold text-slate-900 mb-3  mt-4">
                                        {step.title}
                                    </h3>
                                    <p className="text-slate-600 text-sm leading-relaxed flex-grow">
                                        {step.description}
                                    </p>
                                </div>

                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <SectionStackTechnologies />

            <h2 className={'mt-5'}> Клієнти та партнери — Хто мені вже довіряє?</h2>
            <p>
                5. Клієнти та партнери
                Чому тут: Це блок соціального доказу (Social Proof). Логотипи відомих компаній або відгуки клієнтів на цьому етапі остаточно закривають сумніви щодо вашої авторитетності.
            </p>

            <h2 className={'mt-5'}> Питання-відповідь — Зняття останніх сумнівів.</h2>
            <p>
                6. Питання-відповідь (FAQ)
                Чому тут: Цей розділ працює з останніми запереченнями та типовими питаннями (ціни, терміни, правки), які заважають людині зробити перший крок до замовлення.
            </p>
            <Suspense fallback={<div>Loading...</div>}>
                <Information />
            </Suspense>

            <h2 className={'mt-5'}> Контакти — Заклик до дії (Зв'язатися).</h2>
            <p>
                7. Контакти (Футер)
                Чому тут: Логічне завершення сайту. Клієнт пройшов весь шлях, переконався у вашій експертності й тепер готовий написати або зателефонувати. тут має бути чітка форма заявки або ваші контакти.
            </p>
            <div className="d-flex flex-wrap-reverse align-items-center justify-content-between vh-50 pt-5 pb-5">

                <div className="col-md-6 col-12 d-flex flex-column align-items-start justify-content-center">

                    <h2  className={'opacity-25'}>

                    </h2>
                    <h2 className={'display-3'}>
                        Ready to build something great?
                    </h2>
                    <p className="subtitle mt-3">
                        Let's set up a cel to ciscuss your requirments
                    </p>
                    <Link to={'/cooperation'} className={'btn btn-dark rounded-pill p-3 mt-3 w-50'}>Contact me </Link>

                </div>

                <div className="col-md-6 col-12">
                    <img src="/assets/photo/8.jpeg" alt="Yaroslav Lukyanchuk" className={'img-fluid rounded'}/>
                </div>

            </div>

        </div>
    </div>);
}

export default WorkPage;
